import { useTranslation } from "react-i18next";
import { useState, useRef, useEffect } from "react";
import { Globe, ChevronDown } from "lucide-react";

const LANGS = [
  { code: "it", label: "IT", flag: "🇮🇹", name: "Italiano" },
  { code: "en", label: "EN", flag: "🇬🇧", name: "English" },
  { code: "fr", label: "FR", flag: "🇫🇷", name: "Français" },
];

export default function LanguageSwitcher({ compact = false }) {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = LANGS.find((l) => l.code === i18n.resolvedLanguage) || LANGS[0];

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, []);

  const change = (code) => {
    i18n.changeLanguage(code);
    setOpen(false);
    document.documentElement.lang = code;
  };

  return (
    <div className="relative" ref={ref}>
      <button
        data-testid="language-switcher"
        onClick={() => setOpen(!open)}
        className="inline-flex items-center gap-1.5 px-3 py-2 rounded-full border border-[#E6E2D8] text-sm hover:border-[#8A9A86] transition-colors"
        aria-label="Change language"
      >
        <Globe size={14} strokeWidth={1.5} className="text-[#8A9A86]" />
        <span className="font-medium">{current.label}</span>
        <ChevronDown size={12} strokeWidth={1.5} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-2 w-44 bg-white border border-[#E6E2D8] rounded-2xl shadow-lg overflow-hidden z-50">
          {LANGS.map((l) => (
            <button
              key={l.code}
              data-testid={`lang-option-${l.code}`}
              onClick={() => change(l.code)}
              className={`w-full text-left px-4 py-3 text-sm flex items-center gap-3 hover:bg-[#F3F0EA] transition-colors ${
                l.code === current.code ? "bg-[#F3F0EA]" : ""
              }`}
            >
              <span className="text-lg leading-none">{l.flag}</span>
              <span className="flex-1">{l.name}</span>
              {l.code === current.code && <span className="w-1.5 h-1.5 rounded-full bg-[#8A9A86]" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
